"use strict";
// Copyright (c) Microsoft Corporation. All rights reserved.
Object.defineProperty(exports, "__esModule", { value: true });
exports.usePostInitialRenderCallback = void 0;
const react_1 = require("react");
const usePostInitialRenderCallback = (callback) => {
    const [rendered, setRendered] = (0, react_1.useState)(false);
    const hasFiredCallback = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(() => {
        if (!rendered) {
            setRendered(true);
            return;
        }
        if (hasFiredCallback.current) {
            return;
        }
        let rafId;
        const timeoutId = setTimeout(() => {
            rafId = requestAnimationFrame(() => {
                if (!hasFiredCallback.current) {
                    callback();
                    hasFiredCallback.current = true;
                }
            });
        }, 0);
        return () => {
            clearTimeout(timeoutId);
            cancelAnimationFrame(rafId);
        };
    }, [callback, rendered]);
};
exports.usePostInitialRenderCallback = usePostInitialRenderCallback;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidXNlUG9zdEluaXRpYWxSZW5kZXJDYWxsYmFjay5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9ob29rcy9nZW5lcmljLXV0aWxpdHkvdXNlUG9zdEluaXRpYWxSZW5kZXJDYWxsYmFjay50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsNERBQTREOzs7QUFFNUQsaUNBQW9EO0FBRTdDLE1BQU0sNEJBQTRCLEdBQUcsQ0FBQyxRQUFvQixFQUFRLEVBQUU7SUFDdkUsTUFBTSxDQUFDLFFBQVEsRUFBRSxXQUFXLENBQUMsR0FBRyxJQUFBLGdCQUFRLEVBQUMsS0FBSyxDQUFDLENBQUM7SUFDaEQsTUFBTSxnQkFBZ0IsR0FBRyxJQUFBLGNBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUV2QyxJQUFBLGlCQUFTLEVBQUMsR0FBRyxFQUFFO1FBQ1gsSUFBSSxDQUFDLFFBQVEsRUFBRSxDQUFDO1lBQ1osV0FBVyxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ2xCLE9BQU87UUFDWCxDQUFDO1FBRUQsSUFBSSxnQkFBZ0IsQ0FBQyxPQUFPLEVBQUUsQ0FBQztZQUMzQixPQUFPO1FBQ1gsQ0FBQztRQUVELElBQUksS0FBYSxDQUFDO1FBQ2xCLE1BQU0sU0FBUyxHQUFHLFVBQVUsQ0FBQyxHQUFHLEVBQUU7WUFDOUIsS0FBSyxHQUFHLHFCQUFxQixDQUFDLEdBQUcsRUFBRTtnQkFDL0IsSUFBSSxDQUFDLGdCQUFnQixDQUFDLE9BQU8sRUFBRSxDQUFDO29CQUM1QixRQUFRLEVBQUUsQ0FBQztvQkFDWCxnQkFBZ0IsQ0FBQyxPQUFPLEdBQUcsSUFBSSxDQUFDO2dCQUNwQyxDQUFDO1lBQ0wsQ0FBQyxDQUFDLENBQUM7UUFDUCxDQUFDLEVBQUUsQ0FBQyxDQUFDLENBQUM7UUFFTixPQUFPLEdBQUcsRUFBRTtZQUNSLFlBQVksQ0FBQyxTQUFTLENBQUMsQ0FBQztZQUN4QixvQkFBb0IsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNoQyxDQUFDLENBQUM7SUFDTixDQUFDLEVBQUUsQ0FBQyxRQUFRLEVBQUUsUUFBUSxDQUFDLENBQUMsQ0FBQztBQUM3QixDQUFDLENBQUM7QUE3QlcsUUFBQSw0QkFBNEIsZ0NBNkJ2QyJ9